import { tv } from '@/common/theme/tv.config';

export const styles = {
  icon: 'shrink-0',
  input: tv({
    base: 'mx-sm h-full flex-1 text-md text-neutral30',
    variants: {
      dirty: {
        true: 'font-F37Bold',
        false: 'font-F37',
      },
    },
  }),
};
